import { motion } from "framer-motion";
import { HandHeart, FlaskConical, Building2, ClipboardCheck } from "lucide-react";
import { PROMISE_ITEMS, INTERIOR_IMG } from "@/lib/constants";

const ICONS = { HandHeart, FlaskConical, Building2, ClipboardCheck };

export default function WhyChooseUs() {
  return (
    <section id="why-choose-us" data-testid="why-choose-us-section" className="bg-[#f2ede3]">
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 py-20 md:py-28 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.2, 0.8, 0.2, 1] }}
          className="rounded-2xl overflow-hidden shadow-2xl"
        >
          <img
            src={INTERIOR_IMG}
            alt="Carlton Wellness Center — premium interior"
            data-testid="why-choose-us-image"
            className="w-full h-full object-cover aspect-[4/3] hover:scale-[1.02] transition-transform duration-700"
          />
        </motion.div>

        <div>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9 }}
          >
            <p className="overline text-[#c9a14a]">Why Choose Us</p>
            <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl leading-[1.1] text-[#141414]">
              The Carlton
              <br />
              Wellness Promise
            </h2>
            <p className="mt-6 text-[#4a4a4a] text-base md:text-lg leading-relaxed max-w-md">
              We combine science, tradition and hospitality to deliver measurable wellness
              outcomes in a premium and private environment.
            </p>
          </motion.div>

          <div className="mt-10 grid sm:grid-cols-2 gap-x-10 gap-y-8">
            {PROMISE_ITEMS.map((item, i) => {
              const Icon = ICONS[item.icon];
              return (
                <motion.div
                  key={item.title}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.7, delay: i * 0.1 }}
                  data-testid={`promise-item-${i}`}
                  className="flex gap-4"
                >
                  <span className="w-11 h-11 shrink-0 rounded-lg border border-[#c9a14a]/40 bg-[#c9a14a]/10 flex items-center justify-center text-[#a8813a]">
                    <Icon size={19} strokeWidth={1.5} />
                  </span>
                  <div>
                    <p className="font-semibold text-[#141414] text-[15px]">{item.title}</p>
                    <p className="mt-1.5 text-[13px] text-[#4a4a4a] leading-relaxed">{item.desc}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
